<lucide-icon
    class="ham-tiptap-icon"
    [name]="icon"
    [size]="size"
    [strokeWidth]="strokeWidth"
    aria-hidden="true"
></lucide-icon>
